import styled, { css } from "styled-components";

export const HistoryTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  
  ::-webkit-scrollbar {
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
`;

export const HistoryTableRow = styled.div`
  display: grid;
  min-width: 610px;
  width: 100%;
  grid-template-columns: 280px 300px auto;
  grid-column-gap: 30px;
  flex-shrink: 0;
  justify-content: flex-start;
  padding: ${({ padding,theme }) => padding || theme.table.tableRowPadding};
  border-radius: ${({ borderRadius,theme }) => borderRadius || theme.table.tableRowBorderRadius};
  :nth-of-type(even) {
    background-color: #f8f9fc;
  }
  border-top: ${({ header, theme }) =>
    header && `1px solid ${theme.colors.border.secondary}`};
  border-bottom: ${({ header, theme }) =>
    header && `1px solid ${theme.colors.border.secondary}`};
`;
